// extracted by mini-css-extract-plugin
module.exports = {"sphere":"index_sphere_34Alx","selectcard":"index_selectcard_2q2Km"};